import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Modal, Grid, Breadcrumb, Divider, Button, Form, Radio, Icon, Dropdown } from 'semantic-ui-react';
import { Modal as Confirm } from 'antd';
import { WarningFilled } from '@ant-design/icons';
import styled from 'styled-components';
import update from 'react-addons-update';
import { Time, WeekUI } from '../../Commons';
import * as cm_action from 'actions/commons';
import moment from 'moment-timezone';
moment.tz.setDefault('Asia/Seoul');

import cm from 'helpers/commons';
import toastr from '../../../helpers/toastr';

class SikdaePolicyMod extends Component {
  constructor(props) {
    super(props);
    this.state = {
      holidayUseOption: null,
      holidayUseOptionDescription: {
        DAY_AND_HOLIDAY: '선택한 요일 + 공휴일이어도 사용 가능',
        DAY: '선택한 요일 사용. 단, 공휴일인 경우 사용 불가',
        DAY_OR_HOLIDAY: '선택한 요일 포함 모든 공휴일에 사용 가능'
      },
      isactive: null,
      changeData: {
        startTime: null,
        endTime: null,
        startTime2: null,
        endTime2: null,
        startTime3: null,
        endTime3: null
      },
      dsDate: null,
      deDate: null,
      isNextDay: false,
      uOneday: false,
      cOneday: false,
      nextdayask: ' (내일)',
      nextdayuse: ' (내일)',
      confirmData: {
        open: false,
        content: ''
      }
    };
  }

  //새로운 props를 받았을 시
  static getDerivedStateFromProps(props, state) {
    const { data, holidayUseOption } = props.modal,
      { isactive, changeData } = state;
    const { time } = props;
    if (changeData && !changeData.startTime) {
      return {
        holidayUseOption: holidayUseOption ? holidayUseOption : data ? data.holidayUseOption : null,
        isactive: isactive ? isactive : data ? data.isactive.toString() : null,
        dsDate: time && time.dsDate ? time.dsDate : data && data.demand ? data.demand.starttime : null,
        deDate: time && time.deDate ? time.deDate : data && data.demand ? data.demand.expiretime : null,
        changeData: {
          ...changeData,
          startTime: data && data.startTime ? data.startTime : null,
          endTime: data && data.endTime ? data.endTime : null,
          startTime2: data && data.startTime2 ? data.startTime2 : null,
          endTime2: data && data.endTime2 ? data.endTime2 : null,
          startTime3: data && data.startTime3 ? data.startTime3 : null,
          endTime3: data && data.endTime3 ? data.endTime3 : null
        }
      };
    }
    return state;
  }

  //상태 변경
  //상태
  stateChange = (e, { value }) => {
    this.setState({ isactive: value });
  };

  holidayUseOptionChange = (e, { value }) => {
    this.setState({ holidayUseOption: value });
  };

  //완료 버튼
  sikdaePolicyMod = () => {
    const { sikdaePolicyModFn, close, data } = this.props.modal,
      { changeData } = this.state,
      { time } = this.props,
      isActive = this.state.isactive,
      holidayUseOption = this.state.holidayUseOption,
      params = {
        pIdx: data ? data.idx : null,
        pdIdx: data && data.demand ? data.demand.idx : null,
        holidayUseOption: holidayUseOption,
        isActive: isActive,
        startTime: time.startTime,
        endTime: time.endTime,
        startTime2: time.startTime2,
        endTime2: time.endTime2,
        startTime3: time.startTime3,
        endTime3: time.endTime3
      };
    const startHour = cm.policyUsedTimeHourSplit(time.startTime);
    const endHour = cm.policyUsedTimeHourSplit(time.endTime);
    const startMin = cm.policyUsedTimeMinSplit(time.startTime);
    const endMin = cm.policyUsedTimeMinSplit(time.endTime);
    const startHour2 = cm.policyUsedTimeHourSplit(time.startTime2);
    const endHour2 = cm.policyUsedTimeHourSplit(time.endTime2);
    const startMin2 = cm.policyUsedTimeMinSplit(time.startTime2);
    const endMin2 = cm.policyUsedTimeMinSplit(time.endTime2);
    const startHour3 = cm.policyUsedTimeHourSplit(time.startTime3);
    const endHour3 = cm.policyUsedTimeHourSplit(time.endTime3);
    const startMin3 = cm.policyUsedTimeMinSplit(time.startTime3);
    const endMin3 = cm.policyUsedTimeMinSplit(time.endTime3);

    let isTomorrow = false;
    let isTomorrow1 = false;
    let isTomorrow2 = false;
    let isTomorrow3 = false;

    if (startHour > endHour) {
      isTomorrow = true;
      isTomorrow1 = true;
    }
    if (startHour === endHour && startMin >= endMin) {
      isTomorrow = true;
      isTomorrow1 = true;
    }
    if (time.startTime2 && time.endTime2 && !isTomorrow && startHour2 > endHour2) {
      isTomorrow = true;
      isTomorrow2 = true;
    }
    if (time.startTime2 && time.endTime2 && !isTomorrow && startHour == endHour2 && startMin >= endMin2) {
      isTomorrow = true;
      isTomorrow2 = true;
    }
    if (time.startTime2 && time.endTime2 && startHour2 === endHour2 && startMin2 === endMin2) {
      isTomorrow = true;
      isTomorrow3 = true;
    }
    if (time.startTime3 && time.endTime3 && !isTomorrow && startHour3 > endHour3) {
      isTomorrow = true;
      isTomorrow3 = true;
    }
    if (time.startTime3 && time.endTime3 && !isTomorrow && startHour === endHour3 && startMin3 >= endMin3) {
      isTomorrow = true;
      isTomorrow3 = true;
    }

    if (time.startTime2) {
      // 두번째 사용시간 체크
      if (startHour2 < endHour || (startHour2 === endHour && startMin2 <= endMin)) {
        toastr('top-right', 'error', '사용 시간 시작값은 이전 사용 시간의 종료 시간보다 커야합니다.');
        return;
      }

      if (isTomorrow1) {
        if (
          startHour2 > endHour2 ||
          (startHour === startHour2 && endMin2 > startMin) ||
          (startHour2 >= endHour2 && startMin2 >= endMin2) ||
          (endHour2 > startHour2 && endHour2 > startHour) ||
          (endHour2 > startHour2 && endHour2 === startHour && startMin < endMin2)
        ) {
          toastr('top-right', 'error', '총 사용시간 간격은 24시간을 초과할 수 없습니다.');
          return;
        }
      }

      if (isTomorrow2) {
        if (startHour2 < endHour2 || startHour < endHour2 || (startHour === endHour2 && startMin < endMin2)) {
          toastr('top-right', 'error', '총 사용시간 간격은 24시간을 초과할 수 없습니다.');
          return;
        }
      }

      if (time.startTime3) {
        // 세번째 사용시간 체크
        if (startHour3 < endHour2 || (startHour3 === endHour2 && startMin3 <= endMin2)) {
          toastr('top-right', 'error', '사용 시간 시작값은 이전 사용 시간의 종료 시간보다 커야합니다.');
          return;
        }
        if (isTomorrow) {
          if (
            (startHour === endHour3 && startMin < endMin3) ||
            startHour < endHour3 ||
            (startHour3 > endHour3 && startHour < endHour3) ||
            (startHour3 > endHour3 && startHour > endHour3 && endHour2 < startHour && endHour3 < endHour2) ||
            (startHour3 > endHour3 &&
              startHour > endHour3 &&
              endHour2 < startHour &&
              endHour3 == endHour2 &&
              endMin3 < endMin2) ||
            (startHour === endHour2 && endMin === endMin2 && endHour2 < startHour3) ||
            (startHour3 === endHour3 && startMin3 >= endMin3 && !isTomorrow3)
          ) {
            toastr('top-right', 'error', '총 사용시간 간격은 24시간을 초과할 수 없습니다.');
            return;
          }
        }
        if (isTomorrow1) {
          if (startHour === endHour3 && startMin < endMin3) {
            toastr('top-right', 'error', '총 사용시간 간격은 24시간을 초과할 수 없습니다.');
            return;
          }
        }
      }
    }

    const now = moment()
      .add(1, 'h')
      .format('HH:mm');
    const start = moment(`${startHour}:${startMin}`, 'HH:mm').format('HH:mm');
    let end = moment(`${endHour}:${endMin}`, 'HH:mm').format('HH:mm');
    let bool = false;

    if (data.startTime2) {
      // 두번째 사용시간 체크

      if (data.startTime3) {
        // 세번째 사용시간 체크

        if (data.startTime3 > data.endTime3 || data.startTime2 > data.endTime2 || data.startTime > data.endTime) {
          // 익일 체크
          if (data.startTime < moment().format('HH:mm') || data.endTime3 > moment().format('HH:mm')) {
            this.showConfirm(true, params);
            return;
          }
        } else if (
          data.startTime === data.endTime3 ||
          (data.startTime < moment().format('HH:mm') && data.endTime3 > moment().format('HH:mm'))
        ) {
          this.showConfirm(true, params);
          return;
        }
      }

      if (data.startTime2 > data.endTime2 || data.startTime > data.endTime) {
        // 익일 체크
        if (data.startTime < moment().format('HH:mm') || data.endTime2 > moment().format('HH:mm')) {
          this.showConfirm(true, params);
          return;
        }
      } else if (
        data.startTime === data.endTime2 ||
        (data.startTime < moment().format('HH:mm') && data.endTime2 > moment().format('HH:mm'))
      ) {
        this.showConfirm(true, params);
        return;
      }
    } else if (data.startTime) {
      if (data.startTime > data.endTime) {
        // 익일 체크
        if (data.startTime < moment().format('HH:mm') || data.endTime > moment().format('HH:mm')) {
          this.showConfirm(true, params);
          return;
        }
      } else if (
        data.startTime === data.endTime ||
        (data.startTime < moment().format('HH:mm') && data.endTime > moment().format('HH:mm'))
      ) {
        this.showConfirm(true, params);
        return;
      }
    }

    if (time.startTime) {
      end = time.endTime;
      if (time.startTime2) {
        end = time.endTime2;
        if (time.startTime3) {
          end = time.endTime3;
        }
      }
    }

    if (start <= moment().format('HH:mm') && moment().format('HH:mm') <= end) {
      bool = true;
    } else if (!isTomorrow && start <= end && (now <= start || end <= moment().format('HH:mm'))) {
      bool = false;
    } else if (isTomorrow && end <= start && now <= start && end <= moment().format('HH:mm')) {
      bool = false;
    } else {
      bool = true;
    }
    this.showConfirm(bool, params);
  };

  showConfirm = (isCancel, params) => {
    const { sikdaePolicyModFn, close } = this.props.modal;
    const content1 = `사용시간 변경은 시작 1시간 전, 사용시간이 아닐 때만 가능합니다. 변경가능한 시작 시간은 현재시간 1시간 이후로 설정 가능합니다.`;
    const content2 = `변경된 정책은 바로 반영됩니다. 해당 식대는 돌아오는 사용 시작 시간에 지급됩니다. 변경하시겠습니까?`;
    Confirm.confirm({
      content: isCancel ? content1 : content2,
      icon: null,
      okText: '확인',
      cancelText: isCancel ? '확인' : '취소',
      okButtonProps: isCancel ? { style: { display: 'none' } } : null,
      style: { top: 'calc(50% - 200px)', whiteSpace: 'pre-line', minWidth: '430px' },
      onOk: async () => {
        sikdaePolicyModFn(params);
        close();
      },
      onCancel: async () => {}
    });
  };

  handleCancel = () => {};

  addPolicy = async (e, changeData) => {
    if (changeData && !changeData.startTime2) {
      changeData.startTime2 = '00:00';
      changeData.endTime2 = '00:00';
      changeData.startTime3 = null;
      changeData.endTime3 = null;
      this.setState({
        changeData: changeData
      });
      return;
    }
    if (changeData && !changeData.startTime3) {
      changeData.startTime3 = '00:00';
      changeData.endTime3 = '00:00';
      this.setState({
        changeData: changeData
      });
      return;
    }
  };

  deletePolicy = async (e, changeData) => {
    const { time } = this.props;
    if (changeData && changeData.startTime3) {
      changeData.startTime3 = null;
      changeData.endTime3 = null;
      time.startTime3 = null;
      time.endTime3 = null;
      this.setState({
        changeData: changeData,
        time: time
      });
      return;
    }
    if (changeData && changeData.startTime2) {
      changeData.startTime2 = null;
      changeData.endTime2 = null;
      time.startTime2 = null;
      time.endTime2 = null;
      this.setState({
        changeData: changeData,
        time: time
      });
      return;
    }
  };
  //하루종일
  oneday = async (e, type, data) => {
    document.getElementById('week-btn').blur();
    const { uOneday, cOneday } = this.state;
    const { commonFn } = this.props;

    if (type === 'use') {
      await this.setState({ uOneday: !uOneday });

      commonFn.changeTime({
        type: 'time',
        name: 'sDate',
        value: this.state.uOneday ? '00:00 AM' : moment(data.startTime).format('h:mm A')
      });

      commonFn.changeTime({
        type: 'time',
        name: 'eDate',
        value: this.state.uOneday ? '24:00 PM' : moment(data.expiretime).format('h:mm A')
      });

      document.getElementsByClassName('sDate')[0].getElementsByTagName('input')[0].value = '00:00';
      document.getElementsByClassName('eDate')[0].getElementsByTagName('input')[0].value = '00:00';

      if (cOneday) {
        document.getElementsByClassName('dsDate')[0].getElementsByTagName('input')[0].value = '00:00';
        document.getElementsByClassName('deDate')[0].getElementsByTagName('input')[0].value = '00:00';
      }
    } else if (type === 'change') {
      await this.setState({ cOneday: !cOneday });

      commonFn.changeTime({
        type: 'time',
        name: 'dsDate',
        value: this.state.cOneday ? '00:00 AM' : moment(data.demand.starttime).format('h:mm A')
      });

      commonFn.changeTime({
        type: 'time',
        name: 'deDate',
        value: this.state.cOneday ? '24:00 PM' : moment(data.demand.expiretime).format('h:mm A')
      });

      document.getElementsByClassName('dsDate')[0].getElementsByTagName('input')[0].value = '00:00';
      document.getElementsByClassName('deDate')[0].getElementsByTagName('input')[0].value = '00:00';

      if (uOneday) {
        document.getElementsByClassName('sDate')[0].getElementsByTagName('input')[0].value = '00:00';
        document.getElementsByClassName('eDate')[0].getElementsByTagName('input')[0].value = '00:00';
      }
    }
  };

  close = () => {
    const { close } = this.props.modal;

    this.setState({
      uOneday: false,
      cOneday: false
    });

    close();
  };

  render() {
    const { open, dimmer, data, sikdaePolicy, groupName } = this.props.modal,
      {
        holidayUseOption,
        holidayUseOptionDescription,
        isactive,
        dsDate,
        deDate,
        uOneday,
        cOneday,
        nextdayask,
        nextdayuse,
        changeData
      } = this.state;
    const { time } = this.props;

    let useTime = '';
    let timeComparison1 = false;
    let timeComparison2 = false;
    let timeComparison3 = false;
    if (data) {
      const startHour = cm.policyUsedTimeHourSplit(data.startTime);
      const endHour = cm.policyUsedTimeHourSplit(data.endTime);
      const startMin = cm.policyUsedTimeMinSplit(data.startTime);
      const endMin = cm.policyUsedTimeMinSplit(data.endTime);
      const startHour2 = cm.policyUsedTimeHourSplit(data.startTime2);
      const endHour2 = cm.policyUsedTimeHourSplit(data.endTime2);
      const startMin2 = cm.policyUsedTimeMinSplit(data.startTime2);
      const endMin2 = cm.policyUsedTimeMinSplit(data.endTime2);
      const startHour3 = cm.policyUsedTimeHourSplit(data.startTime3);
      const endHour3 = cm.policyUsedTimeHourSplit(data.endTime3);
      const startMin3 = cm.policyUsedTimeMinSplit(data.startTime3);
      const endMin3 = cm.policyUsedTimeMinSplit(data.endTime3);

      if (startHour > endHour) {
        timeComparison1 = true;
        timeComparison2 = true;
        timeComparison3 = true;
      }
      if (startHour === endHour && startMin >= endMin) {
        timeComparison1 = true;
        timeComparison2 = true;
        timeComparison3 = true;
      }
      if (data.startTime2 && data.endTime2) {
        if (!timeComparison1 && startHour2 > endHour2) {
          timeComparison2 = true;
          timeComparison3 = true;
        }
        if (!timeComparison1 && startHour2 === endHour2 && startMin2 === endMin2) {
          timeComparison2 = true;
          timeComparison3 = true;
        }
        if (!timeComparison1 && startHour === endHour2 && startMin >= endMin2) {
          timeComparison2 = true;
          timeComparison3 = true;
        }
      }
      if (data.startTime3 && data.endTime3) {
        if (!timeComparison2 && startHour3 > endHour3) {
          timeComparison3 = true;
        }
        if (!timeComparison2 && startHour3 === endHour3 && startMin3 === endMin3) {
          timeComparison3 = true;
        }
        if (!timeComparison2 && startHour === endHour3 && startMin === endMin3) {
          timeComparison3 = true;
        }
        if (!timeComparison2 && startHour2 === endHour3 && startMin2 === endMin3) {
          timeComparison3 = true;
        }
        if (!timeComparison2 && startHour3 === endHour3 && startMin3 > endMin3) {
          timeComparison3 = true;
        }
      }
      let startTime = `사용 시간  :  ${data.startTime} ~ ${data.endTime} ${timeComparison1 ? '(내일)' : ''}`;
      let startTime2 = `${
        data.startTime2
          ? ', ' +
            changeData.startTime2 +
            ((timeComparison2 && startHour2 < endHour) || (timeComparison1 && startHour2 >= endHour) ? '(내일)' : '') +
            ' ~ ' +
            data.endTime2 +
            (timeComparison2 ? '(내일)' : '')
          : ''
      }`;
      let startTime3 = `${
        data.startTime3
          ? ', ' +
            data.startTime3 +
            ((timeComparison3 && startHour3 < endHour2) || (timeComparison2 && startHour3 >= endHour2)
              ? '(내일)'
              : '') +
            ' ~ ' +
            data.endTime3 +
            (timeComparison3 ? '(내일)' : '')
          : ''
      }`;
      useTime = startTime + startTime2 + startTime3;
    }

    let info =
      sikdaePolicy && data ? (
        <Modal.Content className="change-policy-modal content-overflow-visible">
          <Grid columns="equal">
            <Grid.Column width={11}>
              <Breadcrumb size="large">
                <Breadcrumb.Section className="title">{groupName}</Breadcrumb.Section>
                <Breadcrumb.Divider icon="right chevron" />
                <Breadcrumb.Section active>{data ? data.name : '-'}</Breadcrumb.Section>
              </Breadcrumb>
            </Grid.Column>
          </Grid>
          {data && data.demand ? (
            <Grid>
              <Grid.Column width={3} className="title">
                신청 시간
              </Grid.Column>
              <Grid.Column width={13}>
                {data
                  ? cm.hhmm(new Date(data.demand.starttime)) + '~' + cm.hhmm(new Date(data.demand.expiretime), 'end')
                  : '-'}
              </Grid.Column>
            </Grid>
          ) : null}
          <Grid>
            <Grid.Column width={3} className="title">
              사용시간
            </Grid.Column>
            <Grid.Column width={13}>{useTime}</Grid.Column>
          </Grid>
          <Grid>
            <Grid.Column width={3} className="title">
              사용요일
            </Grid.Column>
            <Grid.Column width={13}>{data ? data.day.text : '-'}</Grid.Column>
          </Grid>
          <Grid>
            <Grid.Column width={3} className="title">
              공휴일 설정
            </Grid.Column>
            <Grid.Column width={13}>{data ? data.holidayUseOptionName : '-'}</Grid.Column>
          </Grid>
          <Divider />
          {data && data.demand ? (
            <Grid>
              <Grid.Column width={3} className="title">
                변경할 신청시간
              </Grid.Column>
              <Grid.Column width={12} className="change-time-form">
                <Time
                  timeType="dsDate"
                  placeholder={'HH:mm'}
                  defVal={cOneday ? '00:00' : new Date(data.demand.starttime)}
                  isShowSecond={false}
                  isShowMinute={true}
                  isDim={cOneday}
                />
                <Icon className="minus-icon" name="minus" size="mini" />
                <Time
                  timeType="deDate"
                  placeholder={'HH:mm'}
                  isShowSecond={false}
                  isShowMinute={true}
                  defVal={cOneday ? '00:00' : data ? new Date(data.demand.expiretime) : new Date()}
                  isDim={cOneday}
                />
                <Button
                  className={cOneday ? 'week active' : 'week'}
                  style={{ position: 'static' }}
                  id="week-btn"
                  inverted
                  color="black"
                  onClick={(e) => this.oneday(e, 'change', data)}
                >
                  {' '}
                  하루종일
                </Button>
                <span className="">{cm.timeComparison(dsDate, deDate) ? '' : nextdayask}</span>
              </Grid.Column>
            </Grid>
          ) : null}
          <Grid>
            <Grid.Column width={3} className="title">
              변경할 사용시간
            </Grid.Column>
            <Grid.Column width={12} className="time-form">
              <Time
                timeType="startTime"
                placeholder={'HH:mm'}
                isShowSecond={false}
                isShowMinute={true}
                defVal={
                  changeData.startTime
                    ? new Date(
                        1970,
                        3,
                        1,
                        parseInt(changeData.startTime.split(':')[0]),
                        parseInt(changeData.startTime.split(':')[1]),
                        0
                      )
                    : new Date()
                }
              />
              <Icon className="minus-icon" name="minus" size="mini" />
              <Time
                timeType="endTime"
                placeholder={'HH:mm'}
                isShowSecond={false}
                isShowMinute={true}
                defVal={
                  changeData.startTime
                    ? new Date(
                        1970,
                        3,
                        1,
                        parseInt(changeData.endTime.split(':')[0]),
                        parseInt(changeData.endTime.split(':')[1]),
                        0
                      )
                    : new Date()
                }
              />
              <Button
                className={!changeData || !changeData.startTime3 ? 'week active' : 'week none'}
                style={{ position: 'static' }}
                id="week-btn"
                inverted
                color="black"
                onClick={(e) => this.addPolicy(e, changeData)}
              >
                {' '}
                시간 추가
              </Button>
              <Button
                className={changeData && (changeData.startTime2 || changeData.startTime3) ? 'week active' : 'week none'}
                style={{ position: 'static' }}
                id="week-btn"
                inverted
                color="black"
                onClick={(e) => this.deletePolicy(e, changeData)}
              >
                {' '}
                시간 삭제
              </Button>
              {changeData && changeData.startTime2 ? <br /> : null}
              <Time
                timeType="startTime2"
                placeholder={'HH:mm'}
                isShowSecond={false}
                isShowMinute={true}
                defVal={
                  changeData.startTime2
                    ? new Date(
                        1970,
                        3,
                        1,
                        parseInt(changeData.startTime2.split(':')[0]),
                        parseInt(changeData.startTime2.split(':')[1]),
                        0
                      )
                    : 'cleanData'
                }
                isHide={changeData && changeData.startTime2 ? false : true}
                key={`${changeData.startTime2}3` || 3}
              />
              {changeData && changeData.startTime2 ? <Icon className="minus-icon" name="minus" size="mini" /> : ''}
              <Time
                timeType="endTime2"
                placeholder={'HH:mm'}
                isShowSecond={false}
                isShowMinute={true}
                defVal={
                  changeData.endTime2
                    ? new Date(
                        1970,
                        3,
                        1,
                        parseInt(changeData.endTime2.split(':')[0]),
                        parseInt(changeData.endTime2.split(':')[1]),
                        0
                      )
                    : 'cleanData'
                }
                isHide={changeData && changeData.endTime2 ? false : true}
                key={`${changeData.endTime2}4` || 4}
              />
              {changeData && changeData.startTime3 ? <br /> : null}
              <Time
                timeType="startTime3"
                placeholder={'HH:mm'}
                isShowSecond={false}
                isShowMinute={true}
                defVal={
                  changeData.startTime3
                    ? new Date(
                        1970,
                        3,
                        1,
                        parseInt(changeData.startTime3.split(':')[0]),
                        parseInt(changeData.startTime3.split(':')[1]),
                        0
                      )
                    : 'cleanData'
                }
                isHide={changeData && changeData.startTime3 ? false : true}
                key={`${changeData.startTime3}5` || 5}
              />
              {changeData && changeData.startTime3 ? <Icon className="minus-icon" name="minus" size="mini" /> : null}
              <Time
                timeType="endTime3"
                placeholder={'HH:mm'}
                isShowSecond={false}
                isShowMinute={true}
                defVal={
                  changeData.endTime3
                    ? new Date(
                        1970,
                        3,
                        1,
                        parseInt(changeData.endTime3.split(':')[0]),
                        parseInt(changeData.endTime3.split(':')[1]),
                        0
                      )
                    : 'cleanData'
                }
                isHide={changeData && changeData.endTime3 ? false : true}
                key={`${changeData.endTime3}6` || 6}
              />
            </Grid.Column>
          </Grid>
          <Grid>
            <Grid.Column width={3} className="title">
              변경할 요일
            </Grid.Column>
            <Grid.Column width={13}>
              <WeekUI dayValue={data} />
            </Grid.Column>
          </Grid>
          <Grid>
            <Grid.Column width={3} className="title">
              공휴일 설정
            </Grid.Column>
            <Grid.Column width={13}>
              <Dropdown
                selection
                fluid
                value={holidayUseOption}
                options={sikdaePolicy.data.holidayUseOptionList}
                onChange={this.holidayUseOptionChange}
              />
            </Grid.Column>
          </Grid>
          <Grid>
            <Grid.Column width={3} className="title"></Grid.Column>
            <Grid.Column width={13}>{holidayUseOptionDescription[holidayUseOption]}</Grid.Column>
          </Grid>
          <Grid>
            <Grid.Column width={3} className="title">
              상태
            </Grid.Column>
            <Grid.Column width={13}>
              {data ? (
                <Form>
                  <Form.Group inline>
                    <Form.Field
                      control={Radio}
                      label="활성"
                      value="true"
                      checked={isactive === 'true'}
                      onChange={this.stateChange}
                      style={{ marginRight: '28px' }}
                    />
                    <Form.Field
                      control={Radio}
                      label="비활성"
                      value="false"
                      checked={isactive === 'false'}
                      onChange={this.stateChange}
                    />
                  </Form.Group>
                </Form>
              ) : (
                '-'
              )}
            </Grid.Column>
          </Grid>
        </Modal.Content>
      ) : null;
    return (
      <div>
        <Modal dimmer={dimmer} open={open} className="sikdae-policy-mod">
          <Modal.Header>식대 정책 변경</Modal.Header>
          {sikdaePolicy ? info : null}
          <Modal.Actions className="btn-form">
            <GuideText>
              {data && data.type === 'DAY' ? (
                <span className="warning">
                  <WarningFilled />
                  정책 변경 완료시, 변경 시점과 식대 지급 기간의 관계에 따라,
                  <br />
                  반영 시점이 다르니 유념해주시길 바랍니다. 식대 지급이 안될 경우, 식권대장에 문의 바랍니다.
                </span>
              ) : (
                <span>완료를 누르시면 식대 정책이 지금 바로 변경됩니다.</span>
              )}
            </GuideText>
            <Button inverted color="grey" onClick={this.close} style={{ height: 32 }}>
              취소
            </Button>
            <Button positive color="green" content="완료" onClick={(e) => this.sikdaePolicyMod()} />
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}

const GuideText = styled.div`
  text-align: left;
  float: left;
  line-height: 1.5;

  & .warning {
    color: #ff5630;
  }

  & .warning .anticon-warning {
    font-size: 16px;
    padding-right: 6px;
    color: #f29d41;
  }
`;

SikdaePolicyMod = connect(
  (state) => ({
    time: state.commons.time
  }),
  (dispatch) => ({
    commonFn: bindActionCreators(
      {
        changeTime: cm_action.ReduxDataSet
      },
      dispatch
    )
  })
)(SikdaePolicyMod);

export default SikdaePolicyMod;
